// extracted by mini-css-extract-plugin
export default {"innerWrapper":"bw-z","tooltipWrapper":"cw-z","icon":"dw-z","tooltip":"ew-z","content":"fw-z"};